import "./Loader.css";

const LoaderComponent = () => {
    return (
        <div className="preloader">
            <div className="loader">
                <div className="ldio">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        
    );
};

export default LoaderComponent;